import {remCalc} from '_themeUtils'

const sizes = {
    none: '0',
    px: remCalc(1),
    1: remCalc(4),
    2: remCalc(8),
    3: remCalc(12),
    3.5: remCalc(14),
    4: remCalc(16),
    4.5: remCalc(18),
    5: remCalc(20),
    6: remCalc(24),
    6.5: remCalc(26),
    7: remCalc(28),
    8: remCalc(32),
    9: remCalc(36),
    10: remCalc(40),
    10.5: remCalc(42),
    11: remCalc(44),
    11.5: remCalc(46),
    12: remCalc(48),
    13.5: remCalc(54),
    14: remCalc(56),
    16: remCalc(64),
    18: remCalc(72),
    20: remCalc(80),
}

export default sizes
